import { SERVICE_ACCESS_TEMPLATE_CODES } from './ServiceAccessTemplateCode.js';
import { PROGRAM_SECTIONS, DOMAINS_SECTIONS, OPERATIONS_SECTIONS, INVENTORY_SECTIONS, INTERNAL_SECTIONS } from './ServiceSections.js';

// ------------------------------------------------------------
// Services Access Services Templates
// ------------------------------------------------------------
const SERVICE_ACCESS_SERVICES_TEMPLATES = {
    [SERVICE_ACCESS_TEMPLATE_CODES.DEFAULT]: {
        required: [],
        optional: [],
    },
    // Program Owners
    [SERVICE_ACCESS_TEMPLATE_CODES.ACCESS_PROGRAM_OWNER]: {
        required: [
            // Program
            PROGRAM_SECTIONS.WEBSITE,
            PROGRAM_SECTIONS.CHECKOUT,
            PROGRAM_SECTIONS.PROCESSING,
            // Domains
            DOMAINS_SECTIONS.SUBDOMAINS,
            // Operations
            OPERATIONS_SECTIONS.DELIVERY,
        ],
        optional: [
            // Operations
            OPERATIONS_SECTIONS.ASSEMBLY,
            OPERATIONS_SECTIONS.INSPECTION,
            OPERATIONS_SECTIONS.FREIGHT,
            OPERATIONS_SECTIONS.PROCESSING_FEES,
        ],
    },
    [SERVICE_ACCESS_TEMPLATE_CODES.OMNI_PROGRAM_OWNER]: {
        required: [
            // Program
            PROGRAM_SECTIONS.WEBSITE,
            PROGRAM_SECTIONS.CHECKOUT,
            PROGRAM_SECTIONS.PROCESSING,
            // Domains
            DOMAINS_SECTIONS.SUBDOMAINS,
        ],
        optional: [
            // Operations
            OPERATIONS_SECTIONS.DELIVERY,
            OPERATIONS_SECTIONS.ASSEMBLY,
            OPERATIONS_SECTIONS.INSPECTION,
            OPERATIONS_SECTIONS.FREIGHT,
            OPERATIONS_SECTIONS.PROCESSING_FEES,
        ],
    },
    [SERVICE_ACCESS_TEMPLATE_CODES.DEALER_PROGRAM_OWNER]: {
        required: [
            PROGRAM_SECTIONS.WEBSITE,
            PROGRAM_SECTIONS.CHECKOUT,
            PROGRAM_SECTIONS.PROCESSING,
        ],
        optional: [],
    },
    [SERVICE_ACCESS_TEMPLATE_CODES.DEALER_SOLO_ROOFTOP]: {
        required: [
            // Program
            PROGRAM_SECTIONS.WEBSITE,
            PROGRAM_SECTIONS.CHECKOUT,
            PROGRAM_SECTIONS.PROCESSING,
            // Domains
            DOMAINS_SECTIONS.SUBDOMAINS,
            DOMAINS_SECTIONS.SHOP,
            // Inventory
            INVENTORY_SECTIONS.DMS,
            INVENTORY_SECTIONS.SCRAPING,
            INVENTORY_SECTIONS.FIELD_PRECEDENCE,
            // Operations
            OPERATIONS_SECTIONS.SALE,
            OPERATIONS_SECTIONS.DELIVERY,
            OPERATIONS_SECTIONS.PICKUP,
        ],
        optional: [
            // Inventory
            INVENTORY_SECTIONS.GENERAL,
            // Domains
            DOMAINS_SECTIONS.CRM,
            // Operations
            OPERATIONS_SECTIONS.ASSEMBLY,
            OPERATIONS_SECTIONS.INSPECTION,
            OPERATIONS_SECTIONS.FREIGHT,
            OPERATIONS_SECTIONS.COVERAGE_FULFILLMENT,
            OPERATIONS_SECTIONS.FINANCING_BROKERAGE,
            OPERATIONS_SECTIONS.TEMP_TAG,
            OPERATIONS_SECTIONS.PROCESSING_FEES,
        ],
    },
    // Rooftops
    [SERVICE_ACCESS_TEMPLATE_CODES.OMNI_ROOFTOP]: {
        required: [
            // Inventory
            INVENTORY_SECTIONS.DMS,
            // Operations
            OPERATIONS_SECTIONS.SALE,
            OPERATIONS_SECTIONS.DELIVERY,
            OPERATIONS_SECTIONS.ASSEMBLY,
            OPERATIONS_SECTIONS.INSPECTION,
            OPERATIONS_SECTIONS.TITLING,
            OPERATIONS_SECTIONS.REGISTRATION,
        ],
        optional: [
            // Operations
            OPERATIONS_SECTIONS.PICKUP,
            OPERATIONS_SECTIONS.FREIGHT,
            OPERATIONS_SECTIONS.TARIFF,
            OPERATIONS_SECTIONS.PROCESSING_FEES,
        ],
    },
    [SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP]: {
        required: [
            // Inventory
            INVENTORY_SECTIONS.DMS,
            INVENTORY_SECTIONS.SCRAPING,
            INVENTORY_SECTIONS.FIELD_PRECEDENCE,
            // Operations
            OPERATIONS_SECTIONS.SALE,
            OPERATIONS_SECTIONS.DELIVERY,
            OPERATIONS_SECTIONS.PICKUP,
        ],
        optional: [
            // Inventory
            INVENTORY_SECTIONS.GENERAL,
            // Operations
            OPERATIONS_SECTIONS.ASSEMBLY,
            OPERATIONS_SECTIONS.INSPECTION,
            OPERATIONS_SECTIONS.FREIGHT,
            OPERATIONS_SECTIONS.COVERAGE_FULFILLMENT,
            OPERATIONS_SECTIONS.FINANCING_BROKERAGE,
            OPERATIONS_SECTIONS.TEMP_TAG,
        ],
    },
    [SERVICE_ACCESS_TEMPLATE_CODES.PICKUP_LOCATION]: {
        required: [OPERATIONS_SECTIONS.PICKUP],
        optional: [],
    },
    // AI BDC
    [SERVICE_ACCESS_TEMPLATE_CODES.AI_BDC]: {
        required: [
            // Domains
            DOMAINS_SECTIONS.BRANDING,
            // Inventory
            INVENTORY_SECTIONS.DMS,
            INVENTORY_SECTIONS.SCRAPING,
            INVENTORY_SECTIONS.FIELD_PRECEDENCE,
            INVENTORY_SECTIONS.ADMIN_PORTAL,
            INVENTORY_SECTIONS.GENERAL,
        ],
        optional: [],
    },
    // Internal
    [SERVICE_ACCESS_TEMPLATE_CODES.EKHO_FULL_ACCESS]: {
        required: [
            // Program
            PROGRAM_SECTIONS.WEBSITE,
            PROGRAM_SECTIONS.CHECKOUT,
            PROGRAM_SECTIONS.PROCESSING,
            PROGRAM_SECTIONS.CONFIGURATOR,
            // Domains
            DOMAINS_SECTIONS.SUBDOMAINS,
            DOMAINS_SECTIONS.SHOP,
            DOMAINS_SECTIONS.CRM,
            DOMAINS_SECTIONS.BRANDING,
            // Inventory
            INVENTORY_SECTIONS.DMS,
            INVENTORY_SECTIONS.SCRAPING,
            INVENTORY_SECTIONS.FIELD_PRECEDENCE,
            INVENTORY_SECTIONS.ADMIN_PORTAL,
            INVENTORY_SECTIONS.GENERAL,
            // Operations
            OPERATIONS_SECTIONS.SALE,
            OPERATIONS_SECTIONS.DELIVERY,
            OPERATIONS_SECTIONS.PICKUP,
            OPERATIONS_SECTIONS.ASSEMBLY,
            OPERATIONS_SECTIONS.INSPECTION,
            OPERATIONS_SECTIONS.FREIGHT,
            OPERATIONS_SECTIONS.COVERAGE_FULFILLMENT,
            OPERATIONS_SECTIONS.FINANCING_BROKERAGE,
            OPERATIONS_SECTIONS.TARIFF,
            OPERATIONS_SECTIONS.PROCESSING_FEES,
            OPERATIONS_SECTIONS.TEMP_TAG,
            // Internal
            INTERNAL_SECTIONS.COVERAGE_PLATFORM,
            INTERNAL_SECTIONS.COVERAGE_VENDOR,
            INTERNAL_SECTIONS.FINANCING,
            INTERNAL_SECTIONS.FINANCING_BROKERAGE_PLATFORM,
            INTERNAL_SECTIONS.FINANCING_BROKERAGE_SUBVENTION,
        ],
        optional: [],
    },
};

export { SERVICE_ACCESS_SERVICES_TEMPLATES };
//# sourceMappingURL=ServiceAccessServicesTemplates.js.map
